import {FormVisitor} from "./FormVisitor";
import {ReferenceExpression} from "../expressions/ReferenceExpression";
import {ComposedQuestion} from "../definitions/ComposedQuestion";
import {DynamicFormsExpression} from "../expressions/DynamicFormsExpression";

export class NameExtractor extends FormVisitor {
	readonly names: Set<string> = new Set<string>();
	
	protected visitReferenceExpression(expression: ReferenceExpression) {
		this.names.add(expression.name);
	}
	
	static extractNames(node: ComposedQuestion | DynamicFormsExpression): string[] {
		const extractor = new NameExtractor();
		if ("function" in node)
			extractor.walkExpression(node);
		else
			extractor.walkQuestion(node);
		return Array.from(extractor.names);
	}
}
